import { Injectable, inject } from '@angular/core';

import { BtsSendStoreService } from '@app/features/messages/pages/send/pages/area/services/bts-send-store.service';
import { SignalRService } from './signalr.service';

@Injectable({ providedIn: 'root' })
export class SignalRFacadeService {
  private readonly signalR = inject(SignalRService);
  private readonly btsStore = inject(BtsSendStoreService);

  private readonly METHODS = {
    SMART_ZONE_SEND_USER_MESSAGE_ENTRY: 'SmartZoneSendUserMessageEntry',
    SMART_ZONE_SEND_WAITING_RECIPIENT_SELECTION: 'SmartZoneSendWaitingRecipientSelection',
    SMART_ZONE_SEND_WAITING_FOR_ADMIN_MANUAL_REVIEW: 'SmartZoneSendWaitingForAdminManualReview',
    SMART_ZONE_SEND_REJECTED_BY_ADMIN_WAITING_FOR_MIDIFICATION:
      'SmartZoneSendRejectedByAdminWaitingForMidification',
    SMART_ZONE_SEND_APPROVED_BY_ADMIN_WAITING_FOR_PAYMENT:
      'SmartZoneSendApprovedByAdminWaitingForPayment',
  } as const;

  async connect(): Promise<void> {
    await this.signalR.connect();
    this.setupBtsListeners();
  }

  async disconnect(): Promise<void> {
    await this.signalR.disconnect();
  }

  private setupBtsListeners(): void {
    this.signalR.on(this.METHODS.SMART_ZONE_SEND_USER_MESSAGE_ENTRY, (id: unknown) => {
      this.btsStore.notifyUserMessageEntry(Number(id));
    });

    this.signalR.on(this.METHODS.SMART_ZONE_SEND_WAITING_RECIPIENT_SELECTION, (id: unknown) => {
      this.btsStore.notifyWaitingRecipientSelection(Number(id));
    });

    this.signalR.on(this.METHODS.SMART_ZONE_SEND_WAITING_FOR_ADMIN_MANUAL_REVIEW, (id: unknown) => {
      this.btsStore.notifyWaitingForAdminManualReview(Number(id));
    });

    this.signalR.on(
      this.METHODS.SMART_ZONE_SEND_REJECTED_BY_ADMIN_WAITING_FOR_MIDIFICATION,
      (id: unknown) => {
        this.btsStore.notifyRejectedByAdmin(Number(id));
      },
    );

    this.signalR.on(
      this.METHODS.SMART_ZONE_SEND_APPROVED_BY_ADMIN_WAITING_FOR_PAYMENT,
      (id: unknown) => {
        this.btsStore.notifyApprovedForPayment(Number(id));
      },
    );
  }
}
